import { HttpClient, HttpRequest, HttpResponse,
       } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { GalleryImage } from 'app/gallery/gallery.service';
import { ConfigService } from 'core/config/config.service';
import { Severity } from 'core/logging/constants';
import { LoggingService } from 'core/logging/logging.service';
import { ProductService } from 'core/product/product.service';

@Injectable()
export class SteinService
{
  constructor(
    private http: HttpClient,
    @Inject(ConfigService) private configService: ConfigService,
    @Inject(ProductService) private productService: ProductService,
    @Inject(LoggingService) private loggingService
  )
  { }

  public async save_image_information(image: GalleryImage): Promise<void>
  {
    const config = this.configService.getProductDesignerComponentConfig();
    if (!config.steinURL) {
      return;
    }

    const log = (message) => {
      this.loggingService.log('SteinService', Severity.WARNING, message);
    };

    const url = `${config.steinURL}/productdesigner-image-information/`;
    const body = {
        'width': image.width,
        'height': image.height,
        'store': config.catalogStoreId,
        'locale': config.locale,
        'user-agent': window.navigator.userAgent,
        'product': this.productService.getCurrentProduct().id,
    };
    const req = new HttpRequest('POST', url, body);
    try {
      const resp = await this.http.request(req).toPromise();
      if (resp instanceof HttpResponse) {
        if (resp.status < 200 || resp.status > 299) {
          log('invalid response: ' + resp.statusText);
        }
      }
      else {
        log('invalid response');
      }
    }
    catch (error) {
      log('exception raised: ' + error.statusText);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/stein/stein.service.ts